import type { CustomerDto, StoreCustomerResponse, WebSessionResponse } from "@/generated/api/types.gen"

export type { StoreCustomerResponse }

export type StoreCustomer = CustomerDto

export type WebSession = WebSessionResponse

export const confirmedWebSession = (session: Partial<WebSession> | undefined): WebSession => {
  if (typeof session?.userUuid !== "string" || session.userUuid === "") throw new Error("Session identity confirmation is missing")
  return { userUuid: session.userUuid }
}

export type BrowserSessionStatus = { kind: "loading" } | { kind: "anonymous" } | { kind: "authenticated"; userUuid: string } | { kind: "unavailable" }

export interface ForwardedSession {
  cookie: string
  userUuid: string | null
  origin: string
}

export type RequestCredentialKind = "cookie-session" | "verification-bearer" | "checkout-token" | "public"
